import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Dropzone from 'react-dropzone';
import { v4 as uuidv4 } from 'uuid';
import { Dropdown } from '../../components/Dropdown/Dropdown';
import * as Vali from 'helper/validator-helper';
import Form from 'components/react-validation/components/form';
import Textarea from '../../components/react-validation/components/text-area';
import Submit from '../../components/react-validation/components/submit';
import * as LotActionType from '../../Lots/constants';
import * as WOTActionType from '../../Work-Order-Type/constants';
import * as TradeActionType from '../../Trades/constants';
import * as ItemActionType from '../../Items/constants';
import * as SubcontractorActionType from '../../Subcontractors/constants';
import * as ProjectActionType from '../../Projects/constants';
import * as PunchListActionTypes from '../constants';
import Translate from 'components/translate';
import * as DefaultConfigActionType from "../../DefaultConfig/constants"

const MAXIMUM_FILE_SIZE = 1024 * 1024 * 10; //10MB

class AddPunchListItem extends Component {

  static propTypes = {
    dispatch: PropTypes.func,
    toggleModal: PropTypes.func,
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    workOrderTypeList: PropTypes.any,
    TradeList: PropTypes.any,
    ItemRepairList: PropTypes.any,
    ProblemList: PropTypes.any,
    RoomList: PropTypes.any,
    SubcontractorList: PropTypes.any,
    UserList: PropTypes.any,
    PunchListProfile: PropTypes.object,
    IsRedirectToEdit: PropTypes.object,
    ManageWorkOrderTypes: PropTypes.object,
    AWSCredentials: PropTypes.object,
    UserProfile: PropTypes.object,
    DefaultConfigList: PropTypes.array,
  }

  constructor(props) {

    super(props);

    let punchListRefNo = null;

    if (props.match.params.punchListRefNo) {
      punchListRefNo = props.match.params.punchListRefNo;
    }

    this.state = {
      isFetchTrade: false,

      wot: null,
      trade: null,
      itemRepair: null,
      problem: null,
      room: null,
      subcontractor: null,
      user: null,
      userList: [],

      punchListRefNo: punchListRefNo,

      isCheckAnotherProblem: false,

      appointmentDate: null,

      isModeAssignSub: true,
      isInitialUser: false,
      isLoadingLocation: false,
      isLoadingTrade: false,
      isLoadingSubcontractor: false,
      isLoadingUser: false,
      isLoadingItemToRepair: false,
      isLoadingProblem: false,
      isLoadingWorkOrderType: false,
      error: null,

      files: []
    };
  }

  componentDidMount() {
    this.fetchPunchListDetail();
  }

  getDefaultConfigData = async () => {
    await this.props.dispatch({
      type: DefaultConfigActionType.GET_DEFAULT_CONFIG_FOR_DROPDOWN,
      params: null,
      callback: (data) => {
        if (data) {
          this.fetchTrade();
        }
      },
    });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.PunchListProfile &&
        nextProps.PunchListProfile.managedByUser &&
        !this.state.isInitialUser) {
      this.setState({
        user: {
          value: nextProps.PunchListProfile.managedByUser.id,
          text: `${nextProps.PunchListProfile.managedByUser.displayName} (${nextProps.PunchListProfile.managedByUser.email})`,
          extensionValue: {email: nextProps.PunchListProfile.managedByUser.email},
          selected: false
        },
        defaultUser: {
          value: nextProps.PunchListProfile.managedByUser.id,
          text: `${nextProps.PunchListProfile.managedByUser.displayName} (${nextProps.PunchListProfile.managedByUser.email})`,
          extensionValue: {email: nextProps.PunchListProfile.managedByUser.email},
          selected: false
        },
        isInitialUser: true
      });
    }
  }

  fetchPunchListDetail() {
    this.props.dispatch({
      type: PunchListActionTypes.GET_PUNCH_LIST_DETAIL_ASYNC,
      params: {refNo: this.state.punchListRefNo},
      callback:()=>{
      this.getDefaultConfigData();
      }
    });
  }

  onResetForm = () => {
    this.setState({
      itemRepair: null,
      problem: null,
      files: [],
      errorFile: null,
      trade:null, 
      room: null , 
      subcontractor: null,
      user: null
    });
    if (this.form) {
      this.form.resetForm(this.refs);
    }
  }

  onChecked = () => {
    this.setState({
      isCheckAnotherProblem: !this.state.isCheckAnotherProblem
    });
  }

  onSelectChange = (event, name) => {
    this.setState({
      [name]: event.value
    });
    if (name === 'itemRepair') {
      this.setState({
        problem: null
      });
    }
    if (name === 'trade') {
      this.setState({
        subcontractor: null,
        itemRepair: null,
        problem: null
      });
    }
  }

  fetchRoom = () => {
    this.setState({ isLoadingLocation: true });
    this.props.dispatch({
      type: LotActionType.SELECT_ROOM_ASYNC,
      params: {
        id: this.props.PunchListProfile.lot.id,
        searchKey: '',
        selectedValue: '',
        includeSystemRoom: true
      },
      callback: () => this.setState({ isLoadingLocation: false })
    });
  }

  fetchSelectTrade = () => {
    this.setState({ isLoadingTrade: true });
    this.props.dispatch({
      type: LotActionType.SELECT_TRADE_ASYNC,
      params: {
        id: this.props.PunchListProfile.lot.id,
        searchKey: '',
        selectedValue: '',
        setDefaultSelected: false
      },
      callback:()=>{
        this.setState({isLoadingTrade:false });
      }   
    });
  }

  fetchTrade = () => {
    this.setState({ isLoadingTrade: true });
    this.props.dispatch({
      type: LotActionType.SELECT_TRADE_ASYNC,
      params: {
        id: this.props.PunchListProfile.lot.id,
        searchKey: '',
        selectedValue: '',
        setDefaultSelected: false
      },
      callback:(res)=>{
        const propertyData = ["BlueTapeTrade"];
        this.setState({isLoadingTrade:false });
        this.props.DefaultConfigList.map((defaultItem) => {
          res.map((tradeItem) => {
        if (defaultItem.propertyValue === tradeItem.value &&
          propertyData.includes(defaultItem.propertyName)
          ) {
              this.setState({ trade: tradeItem});
              this.fetchItemRepair();
            }
          });
        });
        }
    });
  }

  fetchWOT = () => {
    this.setState({ isLoadingWorkOrderType: true });
    this.props.dispatch({
      type: WOTActionType.SELECT_LIST_WOT_ASYNC,
      params: {
        searchKey: '',
        selectedValue: '',
        setDefaultSelected: false
      },
      callback: () => this.setState({ isLoadingWorkOrderType: false })
    });
  }

  fetchSelectItemRepair = () => {
    if (this.state.trade) {
      this.setState({ isLoadingItemToRepair: true });
      this.props.dispatch({
        type: TradeActionType.SELECT_LIST_ITEM_REPAIR_BY_TRADEID_ASYNC,
        params: {
          id: this.state.trade.value,
          searchKey: '',
          selectedValue: '',
          setDefaultSelected: false
        },
        callback:()=>{
          this.setState({isLoadingItemToRepair:false });
        }     
      });
    }
  }

  fetchItemRepair = () => {
    if (this.state.trade) {
      this.setState({ isLoadingItemToRepair: true });
      this.props.dispatch({
        type: TradeActionType.SELECT_LIST_ITEM_REPAIR_BY_TRADEID_ASYNC,
        params: {
          id: this.state.trade.value,
          searchKey: '',
          selectedValue: '',
          setDefaultSelected: false
        },
        callback: (data) => {
          const propertyData = ["BlueTapeItemRepair"];
          this.setState({isLoadingItemToRepair:false})
          this.props.DefaultConfigList.map((defaultItem) => {
            this.props.ItemRepairList.map((itemtorepairItem) => {
              if (propertyData.includes(defaultItem.propertyName) &&
                defaultItem.propertyValue === itemtorepairItem.value) {
                this.setState({itemRepair:itemtorepairItem})
                this.fetchProblem();
              }
            });
          });
        },      
      });
    }
  }

  fetchSubcontractor = () => {
    if (this.state.trade) {
      this.setState({ isLoadingSubcontractor: true });
      this.props.dispatch({
        type: SubcontractorActionType.SELECT_LIST_SUBCONTRACTOR_ASYNC,
        params: {
          projectId: this.props.PunchListProfile.project.id,
          lotId: this.props.PunchListProfile.lot.id,
          tradeId: this.state.trade.value,
          param: {
            searchKey: '',
            selectedValue: ''
          }
        },
        callback: () => this.setState({ isLoadingSubcontractor: false })
      });
    }
  }

  fetchUser = () => {
    this.setState({ isLoadingUser: true });
    this.props.dispatch({
      type: ProjectActionType.GET_LIST_USER_ASYNC,
      params: {
        projectId: this.props.PunchListProfile.project.id
      },
      callback: () => {
        this.setState({ isFetchedUser: true, isLoadingUser: false });
      }
    });
  }

  fetchSelectProblem = () => {
    if (this.state.itemRepair) {
      this.setState({ isLoadingProblem: true });
      this.props.dispatch({
        type: ItemActionType.SELECT_LIST_PROBLEM_ASYNC,
        params: {
          id: this.state.itemRepair.value,
          searchKey: ''
        },
        callback:()=>{
          this.setState({isLoadingProblem:false });
        }    
      });
    }
  }

  fetchProblem = () => {
    if (this.state.itemRepair) {
      this.setState({ isLoadingProblem: true });
      this.props.dispatch({
        type: ItemActionType.SELECT_LIST_PROBLEM_ASYNC,
        params: {
          id: this.state.itemRepair.value,
          searchKey: ''
        },
        callback: (data) => {
          const propertyData = ["BlueTapeProblem"];
          this.setState({isLoadingProblem:false });
          this.props.DefaultConfigList.map((defaultItem) => {
            data.map((problemItem) => {
              if (propertyData.includes(defaultItem.propertyName) &&
                defaultItem.propertyValue === problemItem.value) {
                this.setState({ problem: problemItem });
              }
            });
          });
        },      
      });
    }
  }

  onSelect = () => {
    this.upload.upload();
  }

  handleCancel = () => {
    this.props.history.push(`/punch-lists/${this.state.punchListRefNo}`);
  }

  handleModeAssign = mode => {
    if (mode === 'sub') {
      this.setState({ isModeAssignSub: true, user: this.state.defaultUser });
    } else {
      this.setState({ isModeAssignSub: false, subcontractor: null });
    }
  }

  onDropOnAttachments = (droppedFiles) => {
    const { files } = this.state;

    //check maximum is 3 files
    if ((files.length + droppedFiles.length) > 3) {
      this.setState({errorFile: 'Maximum 3 files allowed.'});
    }
    else {
      let errorFile = null;
      let currentFiles = [...files];

      // show error message when existing one or more file larger than 10MB
      droppedFiles.map(file => {
        if (file.size > MAXIMUM_FILE_SIZE) {
          errorFile = 'File size must not exceed 10MB.';
        }
        else {
          file['id'] = uuidv4();
          currentFiles.push(file);
        }
      });

      this.setState({
        files: currentFiles,
        errorFile: errorFile
      });
    }
  }

  onSubmit = (e) => {
    e.preventDefault();
    const data = this.form.getValues();
    const { room, trade, subcontractor, user, itemRepair, problem, isModeAssignSub } = this.state;
    let assignedUserId = null;
    let subcontractorId = null;
    if (isModeAssignSub) {
      subcontractorId = subcontractor ? subcontractor.value : null;
    } else {
      assignedUserId = user ? user.value : null;
    }
    const params = {
      title: itemRepair.text + ' - ' + problem.text,
      description: data.description,
      tradeId: trade.value,
      roomId: room.value,
      itemToRepairId: itemRepair.value,
      subcontractorId: subcontractorId,
      assignedUserId: assignedUserId,
      problemId: problem.value
    };

    this.props.dispatch({
      type: PunchListActionTypes.CREATE_PUNCH_LIST_ITEM_ASYNC,
      params: {
        data: params,
        refNo: this.state.punchListRefNo
      },
      callback: (punchItemRefNo, status) => {
        if (status) {
          this.onSetupAWS(punchItemRefNo, this.state.files);
          this.onResetForm();
          this.getDefaultConfigData();
        }
      }
    });
  }

  onSetupAWS = (punchItemRefNo, files) => {
    this.props.dispatch({
      type: PunchListActionTypes.SETUP_PUNCH_LIST_AWS_ASYNC,
      params: {resourcePath: `work-order/${punchItemRefNo}`},
      callback: () => {
        files.map(file => {
          this.props.dispatch({
            type: PunchListActionTypes.UPLOAD_PUNCH_LIST_ATTACHMENT_TO_S3_ASYNC,
            params: {
              refNo: punchItemRefNo,
              config: this.props.AWSCredentials,
              file: file
            },
            callback: (data) => this.onUploadAttachmentsToServer(punchItemRefNo, data, file.name)
          });
        });
      }
    });
  }

  onUploadAttachmentsToServer = (punchItemRefNo, data, fileName) => {
    this.props.dispatch({
      type: PunchListActionTypes.UPLOAD_PUNCH_LIST_ATTACHMENT_TO_SERVER_ASYNC,
      params: {
        refNo: punchItemRefNo,
        data: {
          url: data.Location,
          key: data.Key,
          fileName: fileName
        }
      }
    });
  }

  handleRemoveFile = (file) => {
    let filesState = [...this.state.files];

    filesState = filesState.filter(f => f.id !== file.id);

    this.setState({
      files: filesState,
      errorFile: null
    });
  }

  renderInternalUserDropdown = () => {
    if (this.props.UserProfile.sso) {
      return <Dropdown
        onChange={ref => { this.onSelectChange(ref, 'user'); }}
        filter={true}
        className='filestring-dropdown filter-dropdown'
        onRemote={this.fetchUser}
        options={this.state.isFetchedUser ? this.props.UserList.map(item => { return {...item, text: `${item.text} (${item.extensionValue.email})`}; }) : [{ ...this.state.user }]}
        loading={this.state.isLoadingUser}
        optionLabel='text'
        value={this.state.user}
        showClear={true}
        groupLabels={[
          {
            label: 'System users',
            field: 'sso',
            condition: [true]
          },
          {
            label: 'Builder users',
            field: 'sso',
            condition: [false, null]
          }
        ]}
        name='user'
        placeholder='-- Select a user'
        style={{ width: '100%', paddingLeft: 15 }} />;
    }
    return <Dropdown
      onChange={ref => { this.onSelectChange(ref, 'user'); }}
      filter={true}
      className='filestring-dropdown filter-dropdown'
      onRemote={this.fetchUser}
      options={this.state.isFetchedUser ? this.props.UserList.map(item => { return {...item, text: `${item.text} (${item.extensionValue.email})`}; }) : [{ ...this.state.user }]}
      loading={this.state.isLoadingUser}
      optionLabel='text'
      value={this.state.user}
      showClear={true}
      name='user'
      placeholder='-- Select a user'
      style={{ width: '100%', paddingLeft: 15 }} />;
  }

  renderRequestHomeOwner() {
    // const { RFSProfile } = this.state;

    return (
      <div className='form-group'>
        <div className='col-sm-12'>
          <span className='text-danger'>This request is generated by <Translate translateKey='homeowner' /></span>
        </div>

      </div>
    );
  }

  renderNewWorkOrder() {
    const { room, trade, subcontractor, user, itemRepair, problem, isModeAssignSub } = this.state;
    const disabled = !room || !trade || !itemRepair || !problem || (isModeAssignSub && !subcontractor) || (!isModeAssignSub && !user);

    return (
      <div className='work-order-info-wrapper box-form-siteone col-xs-12 col-lg-12 add-wo-form'>
        <div className='wo-general-info add-punch-item-form clearfix' style={{paddingTop: 25}}>
          <div className='row col-sm-12'>
            <div className='col-sm-6' style={{ paddingLeft: 0 }}>
              <label className='col-sm-12 control-label form-siteone-label'>Location<span className='text-danger'>*</span></label>
              <div className='col-sm-12'>
                <Dropdown
                  onChange={ref => { this.onSelectChange(ref, 'room'); }}
                  filter={true}
                  className='filestring-dropdown filter-dropdown'
                  onRemote={this.fetchRoom}
                  options={this.props.RoomList}
                  optionLabel='text'
                  value={this.state.room}
                  loading={this.state.isLoadingLocation}
                  showClear={true}
                  name='room'
                  placeholder='-- Please select'
                  style={{ width: '100%', paddingLeft: 15 }} />
              </div>
            </div>
          </div>
          <div className='row col-sm-12'>
            <div className='col-sm-6 select-trade'>
              <label className='col-sm-12 control-label form-siteone-label'>Trade<span className='text-danger'>*</span></label>
              <div className='col-sm-12'>
                <Dropdown
                  onChange={ref => { this.onSelectChange(ref, 'trade'); }}
                  filter={true}
                  className='filestring-dropdown filter-dropdown'
                  options={this.props.TradeList}
                  optionLabel='text'
                  onRemote={this.fetchSelectTrade}
                  value={this.state.trade}
                  loading={this.state.isLoadingTrade}
                  showClear={true}
                  name='trade'
                  placeholder='-- Please select'
                  style={{ width: '100%', paddingLeft: 15 }} />
              </div>
            </div>
            <div className='col-sm-6 select-assigned'>
              <div className='col-sm-12 control-label form-siteone-label assign-to-label' style={{marginBottom: 5}}>
                Assigned to <span className='text-danger'>*</span>
                <div className='btn-group btn-group-sm wo-assign-btn-group' role='group'>
                  <button
                    type='button'
                    className={'btn btn-secondary ' + (this.state.isModeAssignSub ? 'active' : '')}
                    onClick={() => { this.handleModeAssign('sub'); }}>subcontractor</button>
                  <button
                    type='button'
                    className={'btn btn-secondary ' + (!this.state.isModeAssignSub ? 'active' : '')}
                    onClick={() => { this.handleModeAssign('user'); }}>internal user</button>
                </div>
              </div>
              <div className='col-sm-12' style={{paddingLeft: 0, paddingRight: 0}}>
                {this.state.isModeAssignSub
                  ? (
                    <Dropdown
                      onChange={ref => { this.onSelectChange(ref, 'subcontractor'); }}
                      filter={true}
                      className='filestring-dropdown filter-dropdown'
                      onRemote={this.fetchSubcontractor}
                      options={this.state.trade ? this.props.SubcontractorList : []}
                      optionLabel='text'
                      value={this.state.subcontractor}
                      loading={this.state.isLoadingSubcontractor}
                      disabled={!this.state.trade}
                      showClear={true}
                      name='subcontractor'
                      placeholder='-- Select a trade first'
                      style={{ width: '100%', paddingLeft: 15, paddingRight: 0 }} />
                  ) : (
                    this.renderInternalUserDropdown()
                  )}
              </div>
            </div>
          </div>
          <div className='row col-sm-12'>
            <div className='col-sm-6' style={{ paddingLeft: 0, paddingRight: 15 }}>
              <label className='col-sm-12 control-label form-siteone-label'>Item to repair <span className='text-danger'>*</span></label>
              <div className='col-sm-12'>
                <Dropdown
                  onChange={ref => { this.onSelectChange(ref, 'itemRepair'); }}
                  filter={true}
                  className='filestring-dropdown filter-dropdown'
                  options={this.state.trade ? this.props.ItemRepairList : []}
                  optionLabel='text'
                  onRemote={this.fetchSelectItemRepair}
                  loading={this.state.isLoadingItemToRepair}
                  value={this.state.itemRepair}
                  disabled={!this.state.trade}
                  showClear={true}
                  name='itemToRepair'
                  placeholder='-- Select a trade first'
                  style={{ width: '100%', paddingLeft: 15 }} />
              </div>
            </div>
            <div className='col-sm-6' style={{ paddingLeft: 0 }}>
              <label className='col-sm-12 control-label form-siteone-label'>Problem <span className='text-danger'>*</span></label>
              <div className='col-sm-12'>
                <Dropdown
                  onChange={ref => { this.onSelectChange(ref, 'problem'); }}
                  className='filestring-dropdown filter-dropdown'
                  options={this.state.itemRepair ? this.props.ProblemList : []}
                  optionLabel='text'
                  onRemote={this.fetchSelectProblem}
                  loading={this.state.isLoadingProblem}
                  value={this.state.problem}
                  disabled={!this.state.itemRepair}
                  showClear={true}
                  name='problem'
                  placeholder='-- Select an item to repair first'
                  style={{ width: '100%', paddingLeft: 15 }} />
              </div>
            </div>
          </div>

          <div className='row col-sm-12 form-group'>
            <label className='col-sm-12 control-label form-siteone-label'>Description</label>
            <div className='col-sm-12' style={{ padding: '0 15px' }}>
              <Textarea
                className='form-control'
                name='description'
                ref='description'
                max='1000'
                maxLength='1000'
                errorMsg='Description is maximum 1000 characters'
                style={{ height: 130 }}
                validations={[Vali.maxlength]} />
            </div>
          </div>

          <div className='row col-sm-12 form-group'>
            <label className='col-sm-12 control-label form-siteone-label'>Attachment</label>
            <Dropzone
              disableClick
              ref={(node) => {this.dropzoneRef = node;}}
              onDrop={this.onDropOnAttachments}
              style={{position: 'initial'}}>
              <span
                className='add-new-attachment-label'
                onClick={() => {this.dropzoneRef.open();}}
                style={{marginLeft: 15}}>
                + Add new attachment
              </span>
            </Dropzone>
            {this.state.errorFile &&
              <div className='text-danger' style={{marginLeft: 15, fontSize: 12}}>{this.state.errorFile}</div>
            }
            {
              this.state.files.map(f =>
                <div key={f.name} style={{marginLeft: 15}}>
                  <span style={{fontStyle: 'italic'}}>{f.name}</span>
                  <i className='fa fa-trash' onClick={() => this.handleRemoveFile(f)} style={{cursor: 'pointer', marginLeft: 15}} />
                </div>
              )
            }
          </div>

          <ul className='wo-detail-bottom-btn' style={{paddingLeft: 40}}>
            <li>
              <span className='btn btn-primary btn-siteone-default punch-item-cancel-btn' onClick={this.handleCancel}>Cancel</span>
            </li>
            <li><Submit className='btn btn-primary btn-submit btn-siteone' disabled={disabled || this.state.error}>Create</Submit></li>
          </ul>

        </div>
      </div>
    );
  }

  render() {
    return (
      <div className='rfs-detail add-new-work-order'>
        <div className='page-title clearfix'>
          {/* <h2 className='pull-left'>Add new blue tape</h2> */}
        </div>
        <ul className='breadcrumb'>
          <li><Link to={'/punch-lists'}>Blue Tapes
            {/* <Translate translateKey='punchlist' capitalize plurals/> */}
            </Link></li>
          <li><Link to={`/punch-lists/${this.state.punchListRefNo}`}>BT #{this.state.punchListRefNo}</Link></li>
          {/* <li className='breadcrumb-siteone-li'>Add new blue tape</li> */}
        </ul>
        <div className='wrapper'>
          <div className='wrapper-form'>
            <Form className='form-horizontal' ref={ref => { this.form = ref; }} onSubmit={this.onSubmit}>
              {this.renderNewWorkOrder()}
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    UserProfile: state.UserStore.UserProfile,
    workOrderTypeList: state.WorkOrderTypesStore.WOTList,
    TradeList: state.LotStore.TradeList,
    ItemRepairList: state.TradeStore.ItemRepairList,
    ProblemList: state.ItemRepairStore.ProblemList,
    RoomList: state.LotStore.RoomList,
    SubcontractorList: state.SubcontractorStore.SubcontractorList,
    UserList: state.ProjectStore.UserSelectList,
    PunchListProfile: state.PunchListStore.PunchListProfile,
    AWSCredentials: state.PunchListStore.AWSCredentials,
    DefaultConfigList: state.CustomorderStore.DefaultConfigList,

  };
};

export default connect(mapStateToProps)(AddPunchListItem);



// WEBPACK FOOTER //
// ./src/Punch-List/Containers/add-punch-list-item.js